module.exports = __webpack_public_path__ + "static/media/logo.f900e653.svg";